<footer class="footer">
    <div class="footer-content justify-content-between">
        <p class="m-b-0">Mesa de Trabalho {{ ano }} - OAB Nacional</p>
        <!--span>
            <a href="" class="text-gray m-r-15">Term &amp; Conditions</a>
            <a href="" class="text-gray">Privacy &amp; Policy</a>
        </span-->
    </div>
</footer>